import { render, staticRenderFns } from "./SignActivityAdd.vue?vue&type=template&id=18b215a7&scoped=true"
import script from "./SignActivityAdd.vue?vue&type=script&lang=js"
export * from "./SignActivityAdd.vue?vue&type=script&lang=js"
import style0 from "./SignActivityAdd.vue?vue&type=style&index=0&id=18b215a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b215a7",
  null
  
)

export default component.exports